// import { useRef } from "react";
// import { useGLTF } from "@react-three/drei";
// import { useFrame } from "@react-three/fiber";

import skyScene from "../assets/3d/sky_lite.glb";

// // 3D Model from: https://sketchfab.com/3d-models/phoenix-bird-844ba0cf144a413ea92c779f18912042
// export function Sky({ isRotating }) {
//   const sky = useGLTF(skyScene);
//   const skyRef = useRef();

//   // Note: Animation names can be found on the Sketchfab website where the 3D model is hosted.
//   // It ensures smooth animations by making the rotation frame rate-independent.
//   // 'delta' represents the time in seconds since the last frame.
//   useFrame((_, delta) => {
//     if (isRotating) {
//       skyRef.current.rotation.y += 0.25 * delta; // Adjust the rotation speed as needed
//     }
//   });

//   return (
//     <mesh ref={skyRef}>
//       // use the primitive element when you want to directly embed a complex 3D
//       model or scene
//       <primitive object={sky.scene} />
//     </mesh>
//   );
// }
// ---------------

/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Author: Paul (https://sketchfab.com/paul_paul_paul)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/free-skybox-thunderstorm-675ee0dc7b7b4709a09f49106cdbdf1f
Title: FREE - SkyBox Thunderstorm
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export function Sky({ isRotating }) {
  const { nodes, materials } = useGLTF(skyScene);
  const skyRef = useRef();
  useFrame((_, delta) => {
    if (isRotating) {
      skyRef.current.rotation.y += 0.25 * delta; // Adjust the rotation speed as needed
    }
  });
  return (
    <group dispose={null} ref={skyRef}>
      <group scale={0.01}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere__0.geometry}
          material={materials["Scene_-_Root"]}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={7000}
        />
      </group>
    </group>
  );
}

// useGLTF.preload("/free_-_skybox_thunderstorm.glb");
